import React from 'react'
import AboutHeroSection from '../AboutUsPage/AboutHeroSection'
import ServicesSection from './ServicesSection'

const ServicesPage = () => {
  return (
    <div>
        <AboutHeroSection pageName={"Services"}/>
        <ServicesSection/>
    </div>
  )
}

export default ServicesPage